'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GoogleButton = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withGoogle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@aws-amplify/core');

var _auth = require('@aws-amplify/auth');

var _auth2 = _interopRequireDefault(_auth);

var _AmplifyUITheme = require('../../Amplify-UI/Amplify-UI-Theme');

var _AmplifyUITheme2 = _interopRequireDefault(_AmplifyUITheme);

var _ui = require('@aws-amplify/ui');

var _AmplifyUIComponentsReact = require('../../Amplify-UI/Amplify-UI-Components-React');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = new _core.ConsoleLogger('withGoogle');

function withGoogle(Comp) {
    return function (_Component) {
        (0, _inherits3.default)(_class, _Component);

        function _class(props) {
            (0, _classCallCheck3.default)(this, _class);

            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.initGapi = _this.initGapi.bind(_this);
            _this.signIn = _this.signIn.bind(_this);
            _this.federatedSignIn = _this.federatedSignIn.bind(_this);

            _this.state = {};
            return _this;
        }

        (0, _createClass3.default)(_class, [{
            key: 'signIn',
            value: function signIn() {
                var _this2 = this;

                var ga = window.gapi.auth2.getAuthInstance();
                var onError = this.props.onError;

                ga.signIn().then(function (googleUser) {
                    return _this2.federatedSignIn(googleUser);
                }, function (error) {
                    if (onError) onError(error);else throw error;
                });
            }
        }, {
            key: 'federatedSignIn',
            value: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(googleUser) {
                    var _googleUser$getAuthRe, id_token, expires_at, profile, user, onStateChange;

                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _googleUser$getAuthRe = googleUser.getAuthResponse(), id_token = _googleUser$getAuthRe.id_token, expires_at = _googleUser$getAuthRe.expires_at;
                                    profile = googleUser.getBasicProfile();
                                    user = {
                                        email: profile.getEmail(),
                                        name: profile.getName()
                                    };
                                    onStateChange = this.props.onStateChange;

                                    if (!(!_auth2.default || typeof _auth2.default.federatedSignIn !== 'function' || typeof _auth2.default.currentAuthenticatedUser !== 'function')) {
                                        _context.next = 6;
                                        break;
                                    }

                                    throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');

                                case 6:
                                    _context.next = 8;
                                    return _auth2.default.federatedSignIn('google', { token: id_token, expires_at: expires_at }, user);

                                case 8:
                                    _context.next = 10;
                                    return _auth2.default.currentAuthenticatedUser();

                                case 10:
                                    user = _context.sent;


                                    if (onStateChange) {
                                        onStateChange('signedIn', user);
                                    }

                                case 12:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function federatedSignIn(_x) {
                    return _ref.apply(this, arguments);
                }

                return federatedSignIn;
            }()
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var google_client_id = this.props.google_client_id;

                if (google_client_id) this.createScript();
            }
        }, {
            key: 'createScript',
            value: function createScript() {
                var script = document.createElement('script');
                script.src = 'https://apis.google.com/js/platform.js';
                script.async = true;
                script.onload = this.initGapi;
                document.body.appendChild(script);
            }
        }, {
            key: 'initGapi',
            value: function initGapi() {
                logger.debug('init gapi');

                var that = this;
                var google_client_id = this.props.google_client_id;

                var g = window.gapi;
                g.load('auth2', function () {
                    g.auth2.init({
                        client_id: google_client_id,
                        scope: 'profile email openid'
                    });
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var ga = window.gapi && window.gapi.auth2 ? window.gapi.auth2.getAuthInstance() : null;
                return _react2.default.createElement(Comp, (0, _extends3.default)({}, this.props, { ga: ga, googleSignIn: this.signIn }));
            }
        }]);
        return _class;
    }(_react.Component);
}

var Button = function Button(props) {
    return _react2.default.createElement(
        _AmplifyUIComponentsReact.SignInButton,
        {
            id: _ui.googleSignInButton,
            onClick: props.googleSignIn,
            theme: props.theme || _AmplifyUITheme2.default
        },
        _react2.default.createElement(
            _AmplifyUIComponentsReact.SignInButtonIcon,
            null,
            _react2.default.createElement(
                'svg',
                { viewBox: '0 0 256 262', xmlns: 'http://ww0w.w3.org/2000/svg', preserveAspectRatio: 'xMidYMid' },
                _react2.default.createElement('path', { d: 'M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027', fill: '#4285F4' }),
                _react2.default.createElement('path', { d: 'M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1', fill: '#34A853' }),
                _react2.default.createElement('path', { d: 'M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782', fill: '#FBBC05' }),
                _react2.default.createElement('path', { d: 'M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251', fill: '#EB4335' })
            )
        ),
        _react2.default.createElement(
            _AmplifyUIComponentsReact.SignInButtonContent,
            null,
            'Sign In with Google'
        )
    );
};

var GoogleButton = exports.GoogleButton = withGoogle(Button);


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-amplify-react/dist/Auth/Provider/withGoogle.js
// module id = 1280
// module chunks = 0